'use strict';

var dataLayer = window.dataLayer || [];

module.exports = {
    // when user book an appointment : bookingFormSubmitted event
    accountLoginSignup: function (type, process) {
        var datalayerObject = {};
        if (type === 'login') {
            datalayerObject.event = 'signIn';
            datalayerObject.signinType = process || 'OTP Login';
        } else {
            datalayerObject.event = 'signUp';
            datalayerObject.signUpType = process || 'Form Signup';
        }
        dataLayer.push(datalayerObject);
    },
    navigationClickHandle: function (navigationMenu) {
        var datalayerObject = {};
        datalayerObject.event = 'myAccountNavigationClick';
        datalayerObject.NavigationMenu = navigationMenu;
        dataLayer.push(datalayerObject);
    },
    wishlistActionHandle: function (wishistAction) {
        var datalayerObject = {};
        datalayerObject.event = 'wishListActions';
        datalayerObject.action = wishistAction;
        dataLayer.push(datalayerObject);
    },
    orderDetailsHandle: function (orderId) {
        var datalayerObject = {};
        datalayerObject.event = 'orderDetails';
        datalayerObject.orderId = orderId;
        dataLayer.push(datalayerObject);
    },
    editDetailsHandle: function (section, pincode) {
        var datalayerObject = {};
        datalayerObject.event = 'editDetails';
        datalayerObject.section = section;
        if (pincode !== '') {
            datalayerObject.pincode = pincode;
        }
        dataLayer.push(datalayerObject);
    },
    deleteAddressHandle: function () {
        var datalayerObject = {};
        datalayerObject.event = 'ctaClick';
        dataLayer.push(datalayerObject);
    },
    successfullDeleteAddressHandle: function (pincode) {
        var datalayerObject = {};
        datalayerObject.event = 'deleteAddress';
        if (pincode !== '') {
            datalayerObject.pincode = pincode;
        }
        dataLayer.push(datalayerObject);
    },
    accordianClickHandle: function (accordianSection) {
        var datalayerObject = {};
        datalayerObject.event = 'accordianClick';
        datalayerObject.accordianSection = accordianSection;
        dataLayer.push(datalayerObject);
    }
};
